import React, { Component } from 'react';
import StudentInfoBtn from '../component/header/studentInfoBtn/studentInfoBtn';
import StudentInfo from '../component/studentInfo/studentInfo';
import ExamTitle from '../component/header/examTitle/examTitle';
import ExamTimer from '../component/header/time/examTimer';
import ExamContainer from '../component/exam/exams/examContainer';
import SheetContainer from '../component/exam/sheet/sheetContainer';
import ExamBtn from '../component/exam/examBtns/examBtn';
import ExamModal from '../component/exam/examModal/examModal';
import Memos from '../component/exam/memo/memos';
import ExamLayoutBtn from '../component/exam/examBtns/examLayoutBtn';
import Footer from '../component/footer/footer';
import '../component/exam/exam.css';

class ExamView extends Component {
    state = {
        examModalClass: false,
        examCheckClass: false,
        examMemoClass: false,
        layloutViewClass: false, // false이면 1단
        examHalfClass: false,
        refValue: '',
    };
    handleOpen = () => {
        const examModalClass = this.state.examModalClass;
        this.setState({examModalClass: true});
        //console.log(`examModalClass State in examView: ${examModalClass}`);
    };
    handlClose = () => {
        const examModalClass = this.state.examModalClass;
        this.setState({examModalClass: false});
        //console.log(`examModalClass State in examView: ${examModalClass}`);
    };

    handleExamChecked = () => {
        const examCheckClass = this.state.examCheckClass;
        this.setState({examCheckClass: !examCheckClass});
    };

    handleExamMemo = () => {
        const examMemoClass = this.state.examMemoClass;
        this.setState({examMemoClass: !examMemoClass});
        //console.log(`examMemoClass: ${examMemoClass}`);
    };

    handleSheetSelect = (radioRef) => {
        const result = radioRef.current.value;
        const refValue = this.state.refValue;
        this.setState({refValue: result});
        console.log(`radioRef: ${refValue}`);
    };

    /*handleLayoutChange = () => {
        const layloutViewClass = this.state.layloutViewClass;
        this.setState({layloutViewClass: !layloutViewClass});
        console.log(`layloutViewClass: ${layloutViewClass}`);
    };*/

    render() {
        return (
            <div className="testView-wrap wrap d-flex flex-column">
                <header className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-grow-1 align-items-center justify-content-between">
                        <StudentInfoBtn onOpen={this.props.onOpen} />
                        <ExamTitle />
                        <div className="d-flex align-items-center right">
                            <ExamLayoutBtn /*layloutViewClass={this.state.layloutViewClass} onLayoutChange={this.handleLayoutChange}*/ />
                            <ExamTimer />
                        </div>
                    </div>
                </header>
                <StudentInfo currentClass={this.props.currentClass} onClose={this.props.onClose} />

                <form>
                    <section className="main-container d-flex w-100 position-relative">
                        <ExamContainer onSheetSelect={this.handleSheetSelect} examHalfClass={this.state.examHalfClass} examCheckClass={this.state.examCheckClass} onExamChecked={this.handleExamChecked} examMemoClass={this.state.examMemoClass} onExamMemo={this.handleExamMemo} />
                        <SheetContainer onSheetSelect={this.handleSheetSelect} examCheckClass={this.state.examCheckClass} examMemoClass={this.state.examMemoClass} />
                    </section>
                </form>

                <Memos examMemoClass={this.state.examMemoClass} onExamMemo={this.handleExamMemo} />
                <ExamModal examModalClass={this.state.examModalClass} onClose={this.handlClose} />

                <footer className="footer-wrap w-100 d-flex justify-content-center align-items-center">
                    <div className="page-btn-wrap d-flex justify-content-center align-content-center"><Footer /></div>
                    <div className="exam-btn-wrap position-absolute d-flex justify-content-center align-items-center"><ExamBtn onOpen={this.handleOpen} /></div>
                </footer>
            </div>
        );
    }
}

export default ExamView;